import React, { Component } from 'react';
import Header from "./header";
import "./homePage.css";
import Footer from "./footer";
import Config from '../../config';
import axios from 'axios';
import { Responsive, Container, Grid, Image, Pagination } from 'semantic-ui-react';
import CentralTimesItem from './CentralTimesItem/CentralTimesItem.js';

const ROOT_URL = Config.ROOT_URL;

class CentralTimes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      centralTimesPagination: {
        data: [],
        page: 1,
        totalPages: 1,
      },
    };
  }

  componentDidMount() {
    this.fetchData(1);
  }

  fetchData(page) {
    axios.get("/data.json")
      .then(res => {
        const allCentralTimes = res.data.centralTimes || [];
        // Basic pagination simulation
        const perPage = 10;
        const totalPages = Math.ceil(allCentralTimes.length / perPage);
        const sliced = allCentralTimes.slice((page - 1) * perPage, page * perPage);

        this.setState({
          centralTimesPagination: {
            data: sliced,
            page: page,
            totalPages: totalPages
          }
        });
      });
  }

  render() {
    const { centralTimesPagination } = this.state;
    return (
      <div className="Homepage">
        <Header page="aboutus" />
        <div className="homeContentWhite">
          <div className="homeContent">

            <Container>
              <div>
                {
                  centralTimesPagination.data.map((item) => {
                    return (
                      <CentralTimesItem data={item} />
                    )
                  })
                }
              </div>
              <div className="margin_top_m">
                <Pagination
                  defaultActivePage={1}
                  totalPages={centralTimesPagination.totalPages}
                  onPageChange={(event, paginationData) => {
                    const activePage = paginationData.activePage;
                    this.fetchData(activePage);
                  }}
                />
              </div>
            </Container>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default CentralTimes;
